export default __webpack_public_path__ + "static/media/fundo.544c4775.png";